import React from 'react';
import LocationTemplate from './LocationTemplate';

const OcracokePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Ocracoke"
      stateName="North Carolina"
      countyName="Hyde"
      zipCodes={["27960"]}
      latitude={35.1154}
      longitude={-75.9871}
      population={948}
      historicalFact="Historic fishing village accessible only by ferry, once the hideout of the pirate Blackbeard."
      nearbyTowns={[
        "Hatteras, NC",
        "Swan Quarter, NC",
        "Cedar Island, NC",
        "Engelhard, NC",
        "Cape Hatteras, NC",
        "Buxton, NC",
        "Avon, NC",
        "Frisco, NC"
      ]}
    />
  );
};

export default OcracokePage;